<template>
	<div class="q-pa-md q-gutter-sm">
		<q-dialog v-model="dialog" position="top" persistent>
			<q-card style="width: 350px">
				<q-linear-progress :value="1" color="primary"></q-linear-progress>

				<q-card-section class="row items-center no-wrap">
					<div class="text-weight-bold">{{ $t('sence_integration') }}</div>

					<q-space></q-space>

					<form ref="form_sense" :action="sence.oauth_url" method="post">
						<input type="hidden" name="RutOtec" v-model="sence.post_data.RutOtec" /> 
						<input type="hidden" name="Token" v-model="sence.post_data.Token" /> 
						<input type="hidden" name="CodSence" v-model="sence.post_data.CodSence" /> 
						<input type="hidden" name="CodigoCurso" v-model="sence.post_data.CodigoCurso" /> 
						<input type="hidden" name="LineaCapacitacion" v-model="sence.post_data.LineaCapacitacion" /> 
						<input type="hidden" name="RunAlumno" v-model="sence.post_data.RunAlumno" /> 
						<input type="hidden" name="IdSesionAlumno" v-model="sence.post_data.IdSesionAlumno" /> 
						<input type="hidden" name="UrlRetoma" v-model="sence.post_data.UrlRetoma" /> 
						<input type="hidden" name="UrlError" v-model="sence.post_data.UrlError" />
						<q-btn :label="$t('session_start')" color="primary" type="submit" />
					</form>
				</q-card-section>

				<q-card-section v-if="sence_error_code" class="text-negative">
					{{ $t(`sence_glosa_error_${sence_error_code}`) }}
				</q-card-section>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
export default {
	i18nOptions: { namespaces: ['sence'] },

	name: 'SenceIntegration',

	data () {
		return {
			sence: {post_data: {}},
			dialog: false,
			sence_error_code: ''
		}
	},

	methods: {
		postSence(){
			this.$q.loading.show()

			let url = ''
			switch (this.$route.name) {
				case 'course_activity': url = `/webservices/universidadechevrolet/chile_sence_login/group_training/${this.$route.params.id}/`
				break
				case 'presential_live_class_activity': url = `/webservices/universidadechevrolet/chile_sence_login/presential_event_date/${this.$route.params.event_id}/`
				break
			}

			this.$axios.get(url)
            .then(response => {
				if (response.data.post_data.CodSence && response.data.post_data.CodigoCurso && response.data.post_data.LineaCapacitacion) {
					this.sence = response.data
					this.dialog = true
				}
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
				this.$q.loading.hide()
				if (this.$route.query.sence_error_code) this.sence_error_code = this.$route.query.sence_error_code
            })
		} 
	},

	created() {
		this.postSence()
	}
}
</script>
